import { createReducer, on } from "@ngrx/store";
import * as SupplierActions from "./supplier.actions";
import { initialSupplierState } from "./supplier.state";

export const supplierReducer = createReducer(
  initialSupplierState,
  on(SupplierActions.loadSuppliers, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(SupplierActions.loadSuppliersSuccess, (state, { suppliers }) => {
    return {
      ...state,
      suppliers,
      loading: false,
    };
  }),
  on(SupplierActions.loadSuppliersFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(SupplierActions.searchSuppliers, (state, {}) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(SupplierActions.searchSuppliersSuccess, (state, { suppliers }) => ({
    ...state,
    loading: false,
    suppliers: suppliers,
  })),

  on(SupplierActions.searchSuppliersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(SupplierActions.createSupplier, (state) => ({
    ...state,
    createSuccess: false,
    createError: null,
  })),

  on(SupplierActions.createSupplierSuccess, (state, { supplier }) => ({
    ...state,
    suppliers: [...state.suppliers, supplier],
    createSuccess: true,
    createError: null,
  })),

  on(SupplierActions.createSupplierFailure, (state, { error }) => ({
    ...state,
    createSuccess: false,
    createError: error,
  })),

  on(SupplierActions.clearSuppliers, () => ({
    ...initialSupplierState,
  })),
  on(SupplierActions.loadSupplierSuccess, (state, { supplier }) => ({
  ...state,
  selectedSupplier: supplier
})),
on(SupplierActions.loadSupplierFailure, (state) => ({
  ...state,
  selectedSupplier: null
})),
on(SupplierActions.updateSupplier, (state) => ({
  ...state,
  updateSuccess: false,
  updateError: null,
})),
on(SupplierActions.updateSupplierSuccess, (state) => ({
  ...state,
  updateSuccess: true,
  updateError: null,
})),
on(SupplierActions.updateSupplierFailure, (state, { error }) => ({
  ...state,
  updateSuccess: false,
  updateError: error,
})),
on(SupplierActions.createSupplierSuccess, (state) => ({
  ...state,
  createSuccess: true
})),
on(SupplierActions.clearSupplierState, state => ({
  ...state,
  createSuccess: false,
  updateSuccess: false,
  createError: null,
  updateError: null,
  selectedSupplier: null
}))

// on(SupplierActions.resetSuccessFlags, (state) => ({
//   ...state,
//   updateSuccess: false,
//   createSuccess: false
// }))



);
